module.exports = __webpack_public_path__ + "img/palm-beach-2.5558f38b.jpg";